<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      :modal-append-to-body="false"
      title="审批流程"
      width="40%"
      style="margin-top: 0"
    >
      <el-form label-position="left" label-width="120px" :model="formList">
        <el-form-item label="预约的活动室" required>
          <el-input v-model="formList.urlName" disabled></el-input>
        </el-form-item>
        <el-form-item label="预定时间" required>
          <el-input v-model="formList.region" disabled></el-input>
        </el-form-item>
        <el-form-item label="活动区域" required>
          <el-input v-model="formList.activityAreaName" disabled></el-input>
        </el-form-item>
        <el-form-item label="预约人" required>
          <el-input v-model="formList.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="参与人">
          <el-input
            placeholder="请选择"
            @focus="changeDep"
            v-model="formList.namelist"
          ></el-input>
        </el-form-item>
      </el-form>
      <div v-if="appPeople">
        <div class="menu"></div>
        <div class="choose">
          审批流程（已由管理员预设不可修改审批人和删除抄送人）
        </div>
        <div>
          <div class="appPeople">审批人</div>
          <div class="app_item">
            <div
              class="approve"
              v-for="item in approver"
              :key="item.approveCode"
            >
              <img :src="item.icon" alt="" /> {{ item.approveName }}
            </div>
          </div>
        </div>
        <div v-if="appmake.length > 0">
          <div class="makePeople">抄送人</div>
          <div class="makeItem">
            <div class="make" v-for="item in appmake" :key="item.approveCode">
              <img :src="item.icon" alt="" />{{ item.approveName }}
            </div>
            <!-- <div class="iconPlus">
              <i class="el-icon-plus" @click="depamentDialogTwo = true"></i>
            </div> -->
          </div>
        </div>
      </div>

      <div slot="footer">
        <div class="submit">
          <el-button class="submitBtn" @click="submit" v-loading='btnLoading'> 提交 </el-button>
        </div>
      </div>
      <!-- <el-button class="submitBtn" @click="submit"> 提交 </el-button> -->
    </el-dialog>
    <depamentDialog
      :visible.sync="depamentDialog"
      @changeQuery="changeQuery"
      :userNames="userNames"
    />
    <depamentDialogTwo
      :visible.sync="depamentDialogTwo"
      @changeQuery="changeQueryTwo"
      :userNames="userNamesTwo"
    />
  </div>
</template>

<script>
import moment from "moment";
import depamentDialog from "./depamentDialog.vue";
import depamentDialogTwo from "./depamentDialogTwo.vue";
import api from "@/apis/reservation";
// import rw from '@/apis/rw';

export default {
  name: "upload",
  props: [
    "visible",
    "ctimeMenuList",
    "startTime",
    "endTime",
    "valueMonth",
    "cText",
    "urlName",
    "urlId",
    "userID",
    "userNa",
    "time",
    "type",
  ],
  components: {
    depamentDialog,
    depamentDialogTwo,
  },
  // props: {
  //   visible: {
  //     type: Boolean,
  //     default: false,
  //   },
  //   ctimeMenuList: {
  //     type: Object,
  //     default: () => {},
  //   },
  // },
  data() {
    return {
      dialogVisible: false,
      list: [],
      formList: {},
      depamentDialog: false,
      depamentDialogTwo: false,
      userNames: [],
      userNamesTwo: [],
      st: "",
      en: "",
      appPeople: false,
      approver: [],
      appmake: [],
      btnLoading:false
    };
  },
  watch: {
    //监听父组件传入的 visible 属性变化
    visible(v) {
      this.dialogVisible = v;
      if (v) {
        this.formList = this.ctimeMenuList;
        if (this.type == "1") {
          this.st = JSON.parse(JSON.stringify(this.startTime));
          this.en = JSON.parse(JSON.stringify(this.endTime));
          this.formList.region = `${this.cText}${this.checkDate(
            this.valueMonth
          )}${this.formatTime(`${this.st}-${this.en}`)}`;
          this.formList.namelist = "";
        } else if (this.type == "2") {
          this.formList.region = `${this.cText}${this.checkDate(
            this.valueMonth
          )}${this.time}`;
          // this.getApprovalDetail();
          if (this.userID && this.userNa) {
            let userIds = this.userID.split(",");
            let nicknames = this.userNa.split(",");
            console.log(userIds, "this.userID");
            console.log(nicknames, "this.userNa");
            let usernames = [];
            for (let i = 0; i < userIds.length; i++) {
              usernames.push({
                username: userIds[i],
                nickname: nicknames[i],
              });
            }
            this.userNames = usernames;
            this.formList.namelist = this.userNa;
            this.formList.idlist = this.userID;
            console.log(this.userNames, "this.userNames");
          }
        }
        this.formList.urlName = this.urlName;
        this.formList.name = this.user.userInfo.nickname;
        console.log(this.ctimeMenuList, "ctimeMenuList");
      }
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("store"));
  },
  methods: {
    // 处理中文标点符号的替换
    replaceChinesePunctuation(str) {
      // 先将中文顿号替换为中文逗号
      let replacedComma = str.replace(/、/g, "，");
      // 再将中文逗号替换为英文逗号
      return replacedComma.replace(/，/g, ",");
    },
    formatHH(timeStr) {
      if (timeStr.includes(":")) {
        // 如果包含冒号，则直接返回原字符串
        return timeStr;
      } else {
        // 如果不包含冒号，则认为是只有小时的数字
        // 将小时转换为数字，确保小时为两位数
        let hour = parseInt(timeStr, 10);
        // 使用模板字符串和padStart方法确保小时为两位数
        // 然后添加':00'作为分钟
        return `${hour.toString().padStart(2, "0")}:00`;
      }
    },
    // 获取审批详情
    getApprovalDetail() {
      api
        .getApprovalDetail({ approveNumber: this.ctimeMenuList.approveNumber })
        .then((data) => {
          console.log(data, "data");
          this.approver = data.data.data.approver;
          this.appmake = data.data.data.notifyer;
          this.appPeople = true;
        });
    },
    // 提交
    submit() {
      // if (!this.formList.namelist) {
      //   this.$message({
      //     type: "warning", // success error warning
      //     message: "请选择参与人",
      //     duration: 2000,
      //   });
      // } else {
        let params = {
          activityRoomId: this.urlId,
          activityAreaId: this.ctimeMenuList.activityAreaId,
          scheduledDate: this.ctimeMenuList.scheduledDate,
          scheduledTime:
            this.type == "2"
              ? this.time
              : `${this.formatHH(this.st)}-${this.formatHH(this.en)}`,
          joinUserName: this.formList.namelist ? this.replaceChinesePunctuation(this.formList.namelist) : '',
          joinUser: this.formList.idlist ? this.replaceChinesePunctuation(this.formList.idlist) : '',
          id: this.type == "2" ? this.ctimeMenuList.id : "",
        };
        this.btnLoading = true
        console.log(params, "params");
        api.addOrUpdate(params).then((data) => {
          console.log(data, "data");
          this.$emit("update:visible", false);
          this.$emit("changeUpload");
          this.userNames = [];
          this.userNamesTwo = [];
          this.btnLoading = false
        })
        .finally(()=>this.btnLoading = false);
      // }
    },
    //搜索
    changeQuery(val) {
      let str = [];
      let id = [];
      this.userNames = [];
      val.length > 0 &&
        val.forEach((item) => {
          str.push(item.nickname);
          id.push(item.username);
          this.userNames.push(item);
        });
      this.formList.namelist = str.join("、");
      this.formList.idlist = id.join("、");
    },
    //搜索
    changeQueryTwo(val) {
      let str = [];
      this.userNamesTwo = [];
      val.length > 0 &&
        val.forEach((item) => {
          str.push(item.nickname);
          this.userNamesTwo.push(item);
        });
      // this.formList.namelist = str.join('、')
    },
    //处理数据
    getList() {
      this.list.forEach((item) => {
        item.checkDate = this.checkDate(moment(item.date).format("YYYY-MM-DD"));
        item.date = moment(item.date).format("MM月DD日");
        item.time = this.formatTime(item.time);
      });
    },
    //转换时间格式
    checkDate(time) {
      const inputMoment = moment(time);
      const now = moment();
      const daysDiff = inputMoment.diff(now, "days");
      const weekDayNum = inputMoment.day();
      const weekDaysShort = [
        "周日",
        "周一",
        "周二",
        "周三",
        "周四",
        "周五",
        "周六",
      ];
      const day = weekDaysShort[weekDayNum];
      let textToday;

      if (inputMoment.isSame(now, "day")) {
        textToday = `今天(${day})`;
      } else if (daysDiff == 0) {
        textToday = `明天(${day})`;
      } else if (daysDiff == 1) {
        textToday = `后天(${day})`;
      } else if (daysDiff >= 2) {
        textToday = `(${day})`;
      } else {
        textToday = "已过期";
      }
      return textToday;
    },
    //格式化时间
    formatTime(timeRange) {
      const [start, end] = timeRange.split("-");
      const [startHour, startMinute = "00"] = start.split(":");
      const [endHour, endMinute = "00"] = end.split(":");

      const formattedStart = `${startHour.padStart(
        2,
        "0"
      )}:${startMinute.padStart(2, "0")}`;
      const formattedEnd = `${endHour.padStart(2, "0")}:${endMinute.padStart(
        2,
        "0"
      )}`;

      return `${formattedStart}-${formattedEnd}`;
    },
    //参与人
    changeDep() {
      console.log("111");
      this.depamentDialog = true;
    },
    //关闭弹窗
    beforeClose(done) {
      this.userNames = [];
      this.userNamesTwo = [];
      this.$emit("update:visible", false);
      done();
    },
    //刷新数据
    finished() {
      this.$emit("update:visible", false);
      this.$emit("changeUpload");
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  // background: rgb(235, 232, 232);
  padding: 20px;
  border-radius: 20px;
  margin-bottom: 20px;
}
.item:hover {
  background: rgb(235, 232, 232);
}
.item_one {
  // margin-top: -30px;
  font-weight: bold;
  font-size: 24px;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .el-dropdown {
    font-size: 28px;
  }
}
.item_two {
  margin: 15px 0;
  font-size: 23px;
}
.item_three {
  margin: 15px 0;
  font-size: 23px;
}
.menu {
  width: 100%;
  height: 1px;
  background: #ccc;
  margin-bottom: 25px;
}
.choose {
  font-size: 20px;
  // margin-bottom: 20px;
}
.appPeople {
  margin: 20px 0 25px;
}
.app_item {
  display: flex;
  align-items: center;
}
.approve {
  background: rgb(241, 240, 240);
  padding: 15px 20px;
  font-size: 20px;
  border-radius: 7px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin-right: 10px;
  }
}
.makePeople {
  margin: 20px 0 25px;
}
.makeItem {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .iconPlus {
    background: rgb(195, 230, 247);
    padding: 15px 30px;
    border-radius: 7px;
    // margin-left: 10px;
    color: rgb(56, 171, 224);
  }
}
.make {
  background: rgb(241, 240, 240);
  padding: 15px 20px;
  font-size: 20px;
  border-radius: 7px;
  margin-right: 15px;
  display: flex;
  align-items: center;
  img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin-right: 10px;
  }
}
.submit {
  display: flex;
  align-items: center;
  justify-content: center;
}
.submitBtn {
  color: #fff;
  background: rgba(50, 106, 251, 1);
  width: 200px !important;
  height: 65px !important;
  border-radius: 100px;
  // position: absolute;
  // left: 50%;
  // bottom: 40px;
  // transform: translate(-50%);
}
::v-deep {
  .el-dialog__body {
    padding: 20px 40px 20px !important;
    height: auto !important;
    overflow: auto;
    position: relative;
    &::-webkit-scrollbar {
      width: 0px;
      height: 1px;
      background-color: rgba(240, 240, 240, 1);
    }
  }
  .el-dialog {
    // height: 70vh !important;
  }
}
</style>
